import { isSuccess } from '@devexperts/remote-data-ts'
import * as rd from '@devexperts/remote-data-ts'
import { cn } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/assets/icons'
import { ExpandedText } from '@/components/ExpandedText'
import { ReservationList } from '@/components/Reservation/List'
import { ReservationLocation } from '@/components/Reservation/Location'
import { StatusAlert } from '@/components/StatusAlert'
import { Surface } from '@/components/Surface'

import { useAppSelector } from '@/hooks/store.ts'
import { useCartRecapData } from '@/hooks/useCartRecapData.ts'
import { isKioskSelector } from '@/store/appSlice'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { insertPeriodSlice } from '@/store/insertPeriodSlice'
import { licenseSlice } from '@/store/licenseSlice'
import { isBookingRefundableSelector } from '@/store/licenseSlice/selectors/isBookingRefundableSelector'
import { formatPrice } from '@/utils/price.ts'

export const ThankYouRecap = () => {
  const { t } = useTranslation()

  const isKiosk = useAppSelector(isKioskSelector)
  const cartRecapData = useCartRecapData(true)
  const creditCardLimit = useAppSelector(licenseSlice.selectors.creditCardLimit)

  let { startDate, endDate } = cartRecapData

  const { deposit, location, region, reservations, beachName, total } =
    cartRecapData

  const cartDetailResponse = useAppSelector(cartSlice.selectors.cartDetail)
  if (rd.isSuccess(cartDetailResponse)) {
    const cartDetail = cartDetailResponse.value
    startDate = new Date(
      cartDetail.cart.reservationModels[0].start_date * 1000
    ).toISOString()
    endDate = new Date(
      cartDetail.cart.reservationModels[0].end_date * 1000
    ).toISOString()
  }

  const isBookingRefundable = useAppSelector(isBookingRefundableSelector)

  const bookingUserDataNotes = useAppSelector(
    licenseSlice.selectors.bookingUserDataNotes
  )

  const bookingPeriod = useAppSelector(
    insertPeriodSlice.selectors.bookingPeriod
  )

  const cartDetail = useAppSelector(cartSlice.selectors.cartDetail)

  return (
    <Surface as="section" className="flex flex-col gap-4 p-4">
      <div className="flex items-center justify-between gap-4">
        <h2 className={cn('text-lg font-bold', { 'text-md': isKiosk })}>
          {t('thankYou.recap.title')}
        </h2>

        {!isKiosk ? (
          <StatusAlert
            className="text-xs"
            {...(isBookingRefundable
              ? {
                  label: t('alerts.refundable'),
                  variant: 'success',
                }
              : {
                  label: t('alerts.notRefundable'),
                  variant: 'danger',
                })}
          />
        ) : null}
      </div>

      <ReservationLocation
        {...{ beachName, bookingPeriod, endDate, location, region, startDate }}
      />

      <p className="flex items-center gap-2 font-bold">
        {formatPrice(Math.min(deposit || total, creditCardLimit ?? Infinity))}

        {isSuccess(cartDetail) && cartDetail.value.cart.weatherPolicy && (
          <span className="rounded-lg bg-yellow-400 px-2 py-0.5 text-xs font-medium text-black">
            {t('common.weatherInsurance')}
          </span>
        )}
      </p>

      <hr />
      <ReservationList mode="thank-you-recap" reservations={reservations} />

      {bookingUserDataNotes && (
        <>
          <hr />

          <div className="flex gap-2">
            <Icon
              className="size-5 flex-shrink-0 text-yellow-300"
              name="NotesIcon"
            />

            <ExpandedText
              label={t('thankYou.beachNotes')}
              text={bookingUserDataNotes}
            />
          </div>
        </>
      )}
    </Surface>
  )
}
